import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const PmsAcquisitionList         = () => import('../../views/pms/acquisition/PmsAcquisitionList.vue');
const PmsAcquisitionRequestEdit  = () => import('../../views/pms/acquisition/PmsAcquisitionRequestEdit.vue');
const PmsAcquisitionListtypeList = () => import('../../views/pms/acquisition/PmsAcquisitionListtypeList.vue');

let meta: MetaData = {
    module: 'pms',
};

let routes: RouteRecordRaw[] = [
    {
        path: '/pms/acquisition',
        name: 'pms-acquisition',
        redirect: {name: 'pms-acquisition-list', params: {type: 'request'}, force: true,},
        meta,
    },
    {
        path: '/pms/acquisition/:type(request|registration)?',
        name: 'pms-acquisition-list',
        component: PmsAcquisitionList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                type: route.params.type || 'request',
            };
        },
    },
    {
        path: '/pms/acquisition/edit/id/:id/:wildcard*',
        name: 'pms-acquisition-request-edit',
        component: PmsAcquisitionRequestEdit,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    {
        path: '/pms/acquisition/add',
        name: 'pms-acquisition-request-add',
        component: PmsAcquisitionRequestEdit,
        props: {id: 0},
        meta,
    },
    {
        path: '/pms/acquisition/listtype/listtype/:listtype(new|refuse|noresubmissions)?',
        name: 'pms-acquisition-listtype-list',
        component: PmsAcquisitionListtypeList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                listtype: route.params.listtype || 'new',
            };
        },
    },
];

export default routes;